theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector("header");
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");

    if (!headerStickyWrapper) return;

    // Set --header-height CSS variable for use by other components (sticky sub-headers, etc.)
    // Measure the .header__sticky element (not the outer <header>) because
    // the wrapper collapses to 0 when its child becomes position:fixed.
    function updateHeaderHeight() {
      const stickyEl = document.querySelector('.header__sticky');
      const height = stickyEl ? stickyEl.offsetHeight : headerStickyWrapper.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    // Set initial height
    updateHeaderHeight();

    // Update on resize (debounced)
    window.addEventListener('resize', debounce(updateHeaderHeight, 150));

    if (headerStickyTargetList.length > 0) {
      headerStickyTargetList.forEach((headerStickyTarget) => {
        window.addEventListener("scroll", function () {
          let StickyTargetElement = TopOffset(headerStickyWrapper);
          let TargetElementTopOffset = StickyTargetElement.top;

          if (window.scrollY > TargetElementTopOffset) {
            headerStickyTarget.classList.add("sticky");
          } else {
            headerStickyTarget.classList.remove("sticky");
          }

          // Update height after sticky state may have changed
          updateHeaderHeight();
        });
      });
    }
  }
  return ScrollSticky;
})();
